import { BaseMeasures } from './BaseMeasures';

export const CollabEditProviderMeasures = new BaseMeasures();
